import {Component, OnInit, OnDestroy} from '@angular/core';


@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent implements OnInit, OnDestroy {

  constructor() { }

  ngOnInit() {
    $('.subHeader').addClass('subCoverServices');
    $('.serviceLink').addClass('activeLink');
    $('.serviceLink a').css('color', 'white');
    $('.headline h1').text('SERVICES');
  }

  ngOnDestroy() {
    $('.subHeader').removeClass('subCoverServices');
    $('.serviceLink').removeClass('activeLink');
  }

  static toTheTop(){
    $('html, body').animate({
      scrollTop: $('#top').offset().top
    }, 500);
  };

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/services/services.component.ts